<template>
  <div class="theline">
    <b v-if="!isMobile()">The Line</b>
    <div class="flexRow blockRow">
      <div
        class="block"
        v-for="(n, i) in blocks"
        :key="i"
        :style="`background-color: ${n.color};}`"
        :class="{ quota: n.quota }"
        :title="n.title"
      />
    </div>
  </div>
</template>

<script>
import util from "../util.js";

export default {
  name: "TheLine",
  mixins: [util.getMobileMixin()],
  props: ["categories"],
  data() {
    return {
      requiredBlocks: {
        exercise: 2,
        meditation: 1,
        projects: 4,
        reading: 2,
        motivation: 1,
      },
    };
  },
  computed: {
    blocks() {
      return Object.keys(this.requiredBlocks)
        .map(k => {
          const blocks = [];
          const category = this.getCategoryByName(k);
          const quota = this.requiredBlocks[k];
          const completed = Object.keys(category.totalBlocks || {}).length;
          for (let i = 0; i < quota; i++) {
            const color = util.colors[category.color];
            const opacity = i < completed ? "ff" : "30";
            blocks.push({
              //RGBA HEX FTW!
              color: color + opacity,
              title: category.name,
              quota: i >= completed,
            });
          }
          return blocks;
        })
        .flat();
    },
  },
  methods: {
    getCategoryByName(name) {
      return Object.values(this.categories).find(e => {
        return e.name.toLowerCase() == name;
      });
    },
  },
};
</script>

<style scoped>
.theline {
  padding: 1rem 0;
  padding-bottom: 0;
}

.quota {
  border: 1px dashed #333;
}

@media (max-width: 600px) {
  .theline {
    padding: 0;
    margin: 0;
    margin-left: auto;
  }
  .blockRow {
    padding: 0;
  }
  .block {
    margin: 0.125rem;
  }
}
</style>



// WEBPACK FOOTER //
// TheLine.vue?0fc87e93